const seasonOptions = [
  { label: "2017", value: "2017" },
  { label: "2018", value: "2018" },
  { label: "2019", value: "2019" }
];

export default seasonOptions;



// WEBPACK FOOTER //
// ./src/constants/seasonOptions.js